module.exports = __webpack_public_path__ + "h5/img/logo.c46dc873.png";